import React from 'react';

function Room(props: object) {
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.75 21H22.25"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 21V3.75C5.75 3.55109 5.82902 3.36032 5.96967 3.21967C6.11032 3.07902 6.30109 3 6.5 3H18.5C18.6989 3 18.8897 3.07902 19.0303 3.21967C19.171 3.36032 19.25 3.55109 19.25 3.75V21"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.875 13.5C13.4963 13.5 14 12.9963 14 12.375C14 11.7537 13.4963 11.25 12.875 11.25C12.2537 11.25 11.75 11.7537 11.75 12.375C11.75 12.9963 12.2537 13.5 12.875 13.5Z"
        fill="currentColor"
      />
      <path
        d="M16.25 3V21"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Room;
